





















































import {Component, Vue} from "vue-property-decorator";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {GroupMessage} from "@/entity/GroupMessage";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {KsChatUserDto} from "@/dto/KsChatUserDto";
import {KsChatUser} from "@/entity/KsChatUser";
import {KsGroup} from "@/entity/KsGroup";

@Component({
  components: {},
})

export default class GroupChat extends Vue {
  message1 = '';
  groupId = this.$route.params.id;
  groupJid = this.$route.params.jid;
  groupName = this.$route.params.name;
  roomName = '';
  static groupMessages: GroupMessage[] = [];
  groupMessages = GroupChat.groupMessages;
  su = SecurityUtils;
  sendJid = this.su.getLoginUser().username + '@rtc1';
  user = this.su.getLoginUser()
  ksGroup = new KsGroup();

  async send() {
    if (this.message1 != '') {
      await XmppUtils.sendGroupMsg(this.sendJid, this.groupJid, this.message1);
      this.groupMessages = GroupChat.groupMessages;
      this.message1 = '';
    }

  }

  async groupSlideDown() {
    setTimeout(() => {
      const height = this.$refs.groupSlideDown as any
      if (height != null) {
        window.scrollTo(0, height.clientHeight + 10000)
      }
    }, 300);
  }

  async mounted() {
    const a = this.groupJid.indexOf('@');
    this.roomName = this.groupJid.substring(0, a);
    const item2 = localStorage.getItem(XmppUtils.username + 'groupMessages' + this.roomName);
    if (item2 != null && item2.length > 2) {
      GroupChat.groupMessages = this.groupMessages = JSON.parse(item2);
    }
    await this.groupSlideDown();
    window.addEventListener('message', (e) => {
      if (e.data === 'groupSlideDown') {
        this.groupMessages = GroupChat.groupMessages;
        setTimeout(() => {
          const height = this.$refs.groupSlideDown as any
          if (height != null) {
            window.scrollTo(0, height.clientHeight)
          }
        }, 100)
      }
    });
    this.ksGroup = await KsChatUserDto.getksgroup(this.groupId);
  }
}
